import { LoadingManager } from './_LoadingManager';
import { StickyContentImageManager } from './_StickyContentImageManager';
import { AnimationPngManager } from './_AnimationPngManager';
import { FadeInManager } from './_FadeInManager';

// DOMContentLoaded 時に各クラスのインスタンスを生成
window.addEventListener('DOMContentLoaded', () => {
  new LoadingManager();
  new StickyContentImageManager();
  new AnimationPngManager();
  new FadeInManager();
});
